import React, { useEffect, useState } from 'react';

import { T } from 'react-translator-component';
import styled from 'styled-components';

import OperationsCommands from './OperationsCommands';
import OperationsExecute from './OperationsExecute';
import OperationsTransfer from './OperationsTransfer';

import {
  getChangeAvailability,
  getGetConfiguration,
  getChangeConfiguration,
  getUnlockConnector,
  getUpdateFirmware,
  getRemoteStartTransaction,
  getRemoteStopTransaction,
  getReset,
  getTriggerMessage,
  getSetChargingProfile,
  getGetDiagnostics,
  getClearCache,
  getClearChargingProfile,
  getDataTransfer, getSendLocalList,
  getGetCompositeSchedule,
  getReserveNow,
} from '../../hooks/operations';

interface IOperations {
  mode: string;
}

const OperationsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  padding: 2em;
`;

const OperationsFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

const Operations = ({ mode }: IOperations) => {
  const [targetKeys, setTargetKeys] = useState<any>([]);
  const [dataSource, setDataSource] = useState<any>({});
  const [menuKey, setMenuKey] = useState<any>('');
  const [, setLoading] = useState<any>(false);
  const [, setOperationResultSource] = useState<any>({});
  const [, setIsExecuted] = useState<any>(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      if (mode === 'v1.5' || mode === 'v1.6')
        switch (menuKey) {
          case 'change_availability':
            setDataSource(await getChangeAvailability(mode));
            break;
          case 'start':
            setDataSource(await getRemoteStartTransaction(mode));
            break;
          case 'stop':
            setDataSource(await getRemoteStopTransaction(mode));
            break;
          case 'reset':
            setDataSource(await getReset(mode));
            break;
          case 'get_configuration':
            setDataSource(await getGetConfiguration(mode));
            break;
          case 'change_configuration':
            setDataSource(await getChangeConfiguration(mode));
            break;
          case 'clear_cache':
            setDataSource(await getClearCache(mode));
            break;
          case 'get_diagnostics':
            setDataSource(await getGetDiagnostics(mode));
            break;
          case 'unlock_connector':
            setDataSource(await getUnlockConnector(mode));
            break;
          case 'update_firmware':
            setDataSource(await getUpdateFirmware(mode));
            break;
          case 'data_transfer':
            setDataSource(await getDataTransfer(mode));
            break;
          case 'trigger_message':
            setDataSource(await getTriggerMessage(mode));
            break;
          case 'set_charging_profile':
            setDataSource(await getSetChargingProfile(mode));
            break;
          case 'clear_charging_profile':
            setDataSource(await getClearChargingProfile(mode));
            break;
          case 'send_local_list':
            setDataSource(await getSendLocalList(mode));
            break;
          case 'get_composite_schedule':
            setDataSource(await getGetCompositeSchedule(mode));
            break;
          case 'reserve_now':
            setDataSource(await getReserveNow(mode));
            break;
          default:
            break;
        }
      setLoading(false);
    })();
  }, [setDataSource, menuKey, mode]);

  return mode !== 'tasks' && mode !== 'charging_profiles' ? (
    <OperationsWrapper>
      <OperationsFlexRow>
        <div>
          <span className='box_title'>{T('Commands')}</span>
          <OperationsCommands mode={mode} setMenuKey={setMenuKey} />
        </div>
        <div>
          <span className='box_title'>{T('Stations')}</span>
          <OperationsTransfer
            targetKeys={targetKeys}
            setTargetKeys={setTargetKeys}
            dataSource={dataSource}
            menuKey={menuKey}
          />
        </div>
        <div>
          <span className='box_title_red'>
            {menuKey !== '' && 'Parâmetros'}
          </span>
          <OperationsExecute
            mode={mode}
            targetKeys={targetKeys}
            dataSource={dataSource}
            menuKey={menuKey}
            setOperationResultSource={setOperationResultSource}
            setIsExecuted={setIsExecuted}
          />
        </div>
      </OperationsFlexRow>
    </OperationsWrapper>
  ) : null;
};

export default Operations;
